<template>
    <div>
        <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <!-- <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
            </div> -->
        </base-header>
        <modal :show.sync="modals.deletePOD"
               gradient="danger"
               modal-classes="modal-danger modal-dialog-centered">
            <h6 slot="header" class="modal-title" id="modal-title-notification"></h6>

            <div class="py-3 text-center" v-if="eliminando == 0">
                <i class="far fa-trash-alt ni-3x"></i>
                <h4 class="heading mt-4">¿Estás seguro?</h4>
                <p>La Factura {{factura_eliminar}} será eliminada.</p>
            </div>
            <div class="py-3 text-center" v-if="eliminando == 1">
                <i class="far fa-trash-alt ni-3x"></i>
                <h4 class="heading mt-4">Eliminando factura {{factura_eliminar}} <br>...</h4>
                <!-- <p>La Factura {{factura_eliminar}} será eliminada.</p> -->
            </div>
            <div class="py-3 text-center" v-if="eliminando == 2">
                <i class="fas fa-check ni-3x"></i>
                <h4 class="heading mt-4">Factura {{factura_eliminar}} eliminada</h4>
                <!-- <p>La Factura {{factura_eliminar}} será eliminada.</p> -->
            </div>
            
            <template slot="footer">
                <base-button type="white" @click="eliminarPOD(factura_eliminar)" v-if="!eliminando">Eliminar factura</base-button>
                <base-button type="link"
                    text-color="white"
                    class="ml-auto"
                    @click="modals.deletePOD = false">
                    Cerrar
                </base-button>
            </template>
        </modal>
        <div class="container-fluid mt--9">
            <!-- Banner de nueva versión -->
            <div v-if="showNewVersionBanner" class="row">
                <div class="col">
                    <div class="card shadow new-version-card">
                        <div class="new-version-body">
                            <div class="new-version-icon">
                                <i class="fas fa-rocket"></i>
                            </div>
                            <h2 class="new-version-title">¡Hay una nueva versión disponible!</h2>
                            <p class="new-version-text">
                                El módulo de <strong>POD</strong> ha sido actualizado y ahora vive en la
                                nueva consola de Canplast. Haz clic en el botón para acceder a la versión más reciente.
                            </p>
                            <a
                                href="https://consola-v2.canplast.net/pod"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="btn btn-new-version"
                            >
                                <i class="fas fa-external-link-alt mr-2"></i>
                                Ir a la nueva consola
                            </a>
                            <button
                                type="button"
                                class="btn-it-authorization"
                                @click="bypassWithITAuthorization"
                            >
                                <i class="fas fa-shield-alt mr-2"></i>
                                Tengo autorización de TI para usar esta versión por esta ocasión
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Vista normal -->
            <div v-else class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row">
                                <div class="col-sm-8">
                                <h3 class="mb-0">PRUEBAS DE ENTREGA</h3>
                                <h4 class="mb-0">{{tipo_pod}}</h4>
                            </div>
                            <div class="col-sm-4">
                                <base-button style="float:right;" tag="a" type="success" href="#" class="active" role="button" aria-pressed="true" @click="mostrarTraslados" v-if="tipo_pod === 'FACTURAS'">Traslados</base-button>
                                <base-button style="float:right;" tag="a" type="success" href="#" class="active" role="button" aria-pressed="true" @click="mostrarTodo" v-if="tipo_pod === 'TRASLADOS'">Mostrar Facturas</base-button>
                            </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <!-- <AllPOD :limit="10"></AllPOD> -->
                            <div class="table-responsive" v-if="tipo_pod === 'FACTURAS'">
                                <div class="row">
                                    <div class="col-sm-2" style="padding-top:10px;">
                                        <base-dropdown style="padding-left:10px">
                                            <base-button slot="title" type="secondary" class="dropdown-toggle">
                                                {{tipo_busqueda}}
                                            </base-button>
                                            <a class="dropdown-item" @click="tipo_busqueda='Factura'">Factura</a>
                                            <a class="dropdown-item" @click="tipo_busqueda='CEDIS'">CEDIS</a>
                                        </base-dropdown>
                                    </div>
                                    <div class="col-sm-5" style="padding-top:10px;" v-if="tipo_busqueda === 'Factura'">
                                        <base-input class="input-group-alternative mb-3"
                                            placeholder="Busqueda"
                                            v-model="busqueda">
                                        </base-input>
                                    </div>
                                    <div class="col-sm-5" style="padding-top:10px;padding-bottom:15px" v-if="tipo_busqueda === 'CEDIS'">
                                        <base-dropdown style="padding-left:10px">
                                            <base-button slot="title" type="secondary" class="dropdown-toggle">
                                                {{cedis_busqueda}}
                                            </base-button>
                                            <a class="dropdown-item" @click="filtrarCEDIS('CUU')">CUU</a>
                                            <a class="dropdown-item" @click="filtrarCEDIS('MEX')">MEX</a>
                                            <a class="dropdown-item" @click="filtrarCEDIS('GDL')">GDL</a>
                                            <a class="dropdown-item" @click="filtrarCEDIS('QRO')">QRO</a>
                                            <a class="dropdown-item" @click="filtrarCEDIS('MTY')">MTY</a>
                                            <a class="dropdown-item" @click="filtrarCEDIS('MID')">MID</a>
                                            <a class="dropdown-item" @click="filtrarCEDIS('TIJ')">TIJ</a>
                                        </base-dropdown>
                                    </div>
                                    <div class="col-sm-2" style="padding-top:10px" v-if="tipo_busqueda === 'Factura'">
                                        <base-button tag="a" type="success" href="#" class="active" role="button" aria-pressed="true" @click="buscarFactura">Buscar</base-button>
                                    </div>
                                </div>
                                
                                <base-table thead-classes="thead-light"
                                            :data="tableData">
                                    <template slot="columns">
                                    <th width="5%" v-if="user.email ==='alfredoreyes@canplast.com.mx' || user.email === 'brendaterrazas@canplast.com.mx' || user.email === 'reynachavez@canplast.com.mx'"></th>
                                    <th width="5%">CEDIS</th>
                                    <th width="5%" :click="sort('fecha')">Fecha Ruta/Entrega</th>
                                    <th width="20%" :click="sort('factura')">Factura</th>
                                    <th width="15%">No. Rastreo / <br> Recibido por</th>
                                    <th width="10%">Chofer</th>
                                    <th width="5%"></th>
                                    <th width="5%"></th>
                                    <th width="5%">Observaciones</th>
                                    </template>

                                    
                                    <template slot-scope="{row}">
                                    <th scope="row" width="5%" v-if="user.email === 'alfredoreyes@canplast.com.mx' || user.email === 'brendaterrazas@canplast.com.mx' || user.email === 'reynachavez@canplast.com.mx'">
                                        <a style="color:red;cursor:pointer;" @click="modals.deletePOD = true;factura_eliminar = row.factura;eliminando = false"><i class="far fa-trash-alt"></i></a>
                                    </th>
                                    <th scope="row" width="5%">
                                        <span class="text-muted" style="font-size:10px">{{row.ubicacion}}</span>
                                    </th>
                                    <th scope="row" width="5%">
                                        <span style="font-size:12px">R: {{row.timestampRuta}}</span><br>
                                        <span style="font-size:12px">E: {{row.timestamp}}</span>
                                    </th>
                                    <th scope="row" width="20%">
                                        <span style="font-size:12px">{{row.factura}}</span><br>
                                        <span class="text-muted" style="font-size:10px">{{row.clienteNombre}}</span>
                                    </th>
                                    <th scope="row" v-if="row.paqueteria === 'RUTA LOCAL'" width="15%">
                                        <span style="font-size:12px">{{row.rastreo}}</span><br>
                                        <span class="text-muted" style="font-size:10px">{{row.recibio}}</span>
                                    </th>
                                    <th scope="row" v-else width="15%">
                                        <span style="font-size:12px">{{row.paqueteria}}</span><br>
                                        <span class="text-muted" style="font-size:10px">{{row.rastreo}}</span>
                                    </th>
                                    <th width="10%" class="text-muted">
                                        {{row.choferNombre}}
                                    </th>
                                    <th width="5%">
                                        <center>
                                        <a :href="row.url_photo" target="blank"><i class="ni ni-image" style="color:black;font-size:22px;"></i></a>
                                        </center>
                                    </th>
                                    <th width="5%">
                                        <center v-if="row.url_rastreo != ''">
                                        <a :href="row.url_rastreo" target="blank"><i class="ni ni-delivery-fast" style="color:black;font-size:22px;"></i></a>
                                        </center>
                                    </th>
                                    <th width="5%">
                                        <center v-if="row.observaciones != '' && row.observaciones != null">
                                            <!-- <i class="ni ni-chat-round" style="color:black;font-size:22px;"></i> -->
                                            <pre class="xml" v-text="row.observaciones"/>
                                            <!-- <tooltip/> -->
                                        </center>
                                    </th>
                                    </template>
                                </base-table>
                                <div v-if="!facturaEncontrada" style="padding-top:15px;">
                                    <center>
                                        <h3>FACTURA NO ENCONTRADA</h3>
                                    </center>    
                                </div>
                                <center v-if="showLoader"><img src="img/loader.gif" class="img-responsive" style="width:50px;padding-bottom:5px;padding-top:13px"><br>Cargando...</center>
                                <div style="padding-top:15px;"  v-if="showCargarMasBtnCEDIS && filtroUsado">
                                    <base-button block @click="cargarCEDISPOD">Cargar más de {{cedis_busqueda}} ...</base-button>
                                </div>
                                <div style="padding-top:15px;"  v-if="filtroUsado">
                                    <base-button block @click="mostrarTodo">Mostrar todas las POD</base-button>
                                </div>
                                <div style="padding-top:15px;"  v-if="showCargarMasBtn && !filtroUsado">
                                    <base-button block @click="cargarPOD">Cargar más...</base-button>
                                </div>
                                <div class="card-footer d-flex justify-content-end">
                                    <!-- <button :click="prevPage">Previous</button>  -->
                                    <!-- <button :click="nextPage">Next</button> -->
                                    <!-- <base-pagination :perPage="tableData.lenght/2" v-model="tableData.lenght"></base-pagination> -->
                                </div>
                            </div>
                            <div class="table-responsive" v-if="tipo_pod === 'TRASLADOS'">
                                <div class="row">
                                    <div class="col-sm-2" style="padding-top:10px;">
                                        <base-dropdown style="padding-left:10px">
                                            <base-button slot="title" type="secondary" class="dropdown-toggle">
                                                {{tipo_busquedaTraslado}}
                                            </base-button>
                                            <a class="dropdown-item" @click="tipo_busquedaTraslado='No. Traslado'">No. Traslado</a>
                                        </base-dropdown>
                                    </div>
                                    <div class="col-sm-5" style="padding-top:10px;">
                                        <base-input class="input-group-alternative mb-3"
                                            placeholder="Busqueda"
                                            v-model="busquedaTraslado">
                                        </base-input>
                                    </div>
                                    <div class="col-sm-2" style="padding-top:10px">
                                        <base-button tag="a" type="success" href="#" class="active" role="button" aria-pressed="true" @click="buscarTraslado">Buscar</base-button>
                                    </div>
                                </div>
                                
                                <base-table thead-classes="thead-light"
                                            :data="tableDataTraslado">
                                    <template slot="columns">
                                    <th width="5%" :click="sort('fecha')">Fecha</th>
                                    <th width="20%" :click="sort('traslado')">Traslado / Destino</th>
                                    <th width="15%">Paquetería / <br> No. Rastreo</th>
                                    <th width="10%">Chofer</th>
                                    <th width="5%"></th>
                                    <th width="5%"></th>
                                    <th width="5%">Observaciones</th>
                                    </template>


                                    <template slot-scope="{row}">
                                    <th scope="row" width="5%">
                                        <span style="font-size:12px">{{row.dateFormatted}}</span><br>
                                        <span class="text-muted" style="font-size:10px">{{row.ubicacion}}</span>
                                    </th>
                                    <th scope="row" width="20%">
                                        <span style="font-size:12px">{{row.traslado}}</span><br>
                                        <span class="text-muted" style="font-size:10px">{{row.destino}}</span>
                                    </th>
                                    <th scope="row" width="20%">
                                        <span style="font-size:12px">{{row.paqueteria}}</span><br>
                                        <span class="text-muted" style="font-size:10px">{{row.rastreo}}</span>
                                    </th>
                                    <th width="10%" class="text-muted">
                                        {{row.choferNombre}}
                                    </th>
                                    <th width="5%">
                                        <center>
                                        <a :href="row.url_photo" target="blank"><i class="ni ni-image" style="color:black;font-size:22px;"></i></a>
                                        </center>
                                    </th>
                                    <th width="5%">
                                        <center v-if="row.url_rastreo != ''">
                                        <a :href="row.url_rastreo" target="blank"><i class="ni ni-delivery-fast" style="color:black;font-size:22px;"></i></a>
                                        </center>
                                    </th>
                                    <th width="5%">
                                        <center v-if="row.observaciones != '' && row.observaciones != null">
                                            <!-- <i class="ni ni-chat-round" style="color:black;font-size:22px;"></i> -->
                                            <pre class="xml" v-text="row.observaciones"/>
                                            <!-- <tooltip/> -->
                                        </center>
                                    </th>
                                    </template>
                                </base-table>
                                <div style="padding-top:15px;"  v-if="filtroTrasladoUsado">
                                    <base-button block @click="mostrarTraslados">Mostrar todos los traslados</base-button>
                                </div>
                                <div style="padding-top:15px;"  v-if="showCargarMasTrasladosBtn && !filtroTrasladoUsado">

                                    <base-button block @click="cargarTraslados">Cargar más...</base-button>
                                </div>
                                <center v-if="showLoader"><img src="img/loader.gif" class="img-responsive" style="width:50px;padding-bottom:5px;padding-top:13px"><br>Cargando...</center>
                                <div class="card-footer d-flex justify-content-end">
                                    <!-- <button :click="prevPage">Previous</button>  -->
                                    <!-- <button :click="nextPage">Next</button> -->
                                    <!-- <base-pagination :perPage="tableData.lenght/2" v-model="tableData.lenght"></base-pagination> -->
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
//  import SocialTrafficTable from './Dashboard/SocialTrafficTable';
  import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
  import moment from 'moment'
  // Importaciones de Firebase (API modular v11)
import { getAuth, getIdToken } from 'firebase/auth'
import { isLegacyRetired } from '@/legacyAccess'
import { 
  getFirestore, collection, query, orderBy, limit, getDocs, 
  where, startAt 
} from 'firebase/firestore'
  
  Vue.use(VueClipboard)
  export default {
    components:{
//        SocialTrafficTable,
    },
    directives: {
      'b-tooltip': BTooltipDirective
    },
    created() {
        // Autenticación modular
        const auth = getAuth()
        this.user = auth.currentUser
        if (auth.currentUser) {
        getIdToken(auth.currentUser, true)
            .then((idToken) => {
            fetch('https://canplast.net:50000/api/v1/auth/verifyToken', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token: idToken })
            })
            .then((response) => response.json())
            .then((responseJson) => {
                localStorage.setItem('token-cpm', responseJson.token)
            })
            .catch((error) => {
                console.error(error)
            })
            })
            .catch((error) => {
            console.error(error)
            })
        }
    },
    async beforeMount() {
        const db = getFirestore()
        const podQuery = query(
            collection(db, "pod"),
            orderBy("timestamp", "desc"),
            limit(100)
        )
        try {
        const querySnapshot = await getDocs(podQuery)
        querySnapshot.forEach((doc) => {
            const data = doc.data()
            if (data.factura) {
            let url = ''
            const paqueteriaQuery = query(
                collection(db, 'paqueterias'),
                where('name', '==', data.paqueteria)
            )
            getDocs(paqueteriaQuery).then((qs2) => {
                qs2.forEach((doc2) => {
                const paqData = doc2.data()
                if (paqData.url) {
                    url = paqData.url.replace("{NUM_RASTREO}", data.rastreo)
                }
                })
            })
            // Se usa setTimeout para emular el retardo en obtener la URL
            setTimeout(() => {
                this.tableData.push({
                choferNombre: data.choferNombre,
                choferTelefono: data.choferTelefono,
                clienteCodigo: data.clienteCodigo,
                clienteNombre: data.clienteNombre,
                dateFormatted: data.dateFormatted,
                factura: data.factura,
                fecha: data.fecha,
                observaciones: data.observaciones,
                paqueteria: data.paqueteria,
                rastreo: data.rastreo,
                recibio: data.recibio,
                timestamp: moment(moment.unix(data.timestamp)).format("YYYY-MM-DD HH:mm"),
                timestampRuta: moment(moment.unix(data.timestampRuta)).format("YYYY-MM-DD HH:mm"),
                tipo_entrega: data.tipo_entrega,
                ubicacion: data.ubicacion,
                url_rastreo: url,
                url_photo: data.url_photo
                })
            }, 400)
            }
        })
        this.showLoader = false
        this.showCargarMasBtn = true
        } catch (error) {
        console.error("Error obteniendo PODs: ", error)
        }
    },
    data() {
        return {
        modals:{
            deletePOD:false
        },
        tableData: [],
        tableDataTraslado: [],
        showLoader: true,
        showCargarMasBtn: false,
        showCargarMasTrasladosBtn: false,
        showCargarMasBtnCEDIS: false,
        tipo_busqueda: 'Factura',
        busqueda:'',
        tipo_busquedaTraslado: 'No. Traslado',
        busquedaTraslado:'',
        filtroUsado: false,
        filtroTrasladoUsado: false,
        showTraslados: false,
        tipo_pod: 'FACTURAS',
        facturaEncontrada: true,
        cedis_busqueda: 'Selecciona un CEDIS',
        user:null,
        factura_eliminar: null,
        eliminando: 0,
        showNewVersionBanner: !isLegacyRetired()
        }
    },
    methods:{
        bypassWithITAuthorization() {
            this.$swal
                .fire({
                    title: "¿Tienes autorización de TI?",
                    text: "Solo continúa si TI te autorizó expresamente a usar esta versión por esta ocasión.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sí, tengo autorización",
                    cancelButtonText: "Cancelar",
                    reverseButtons: true,
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.showNewVersionBanner = false;
                    }
                });
        },
        eliminarPOD(factura) {
            this.eliminando = 1
            const db = getFirestore()
            const podQuery = query(
                collection(db, 'pod'),
                where('factura', '==', factura)
            )
            getDocs(podQuery).then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                // En modular no se usa directamente .delete() sobre el doc;
                // Se obtiene la referencia y se llama a deleteDoc (importable desde 'firebase/firestore')
                doc.ref.delete()
                })
            })
            setTimeout(() => {
                this.eliminando = 2
                this.mostrarTodo()
            }, 1000)
        },
        async filtrarCEDIS(cedis_busqueda) {
            this.cedis_busqueda = cedis_busqueda
            this.tipo_pod = 'FACTURAS'
            this.busqueda = ''
            this.facturaEncontrada = true
            this.showCargarMasBtn = false
            const db = getFirestore()
            const podQuery = query(
                collection(db, "pod"),
                where('ubicacion', '==', cedis_busqueda + '-02'),
                orderBy("timestamp", "desc"),
                limit(100)
            )
            try {
                const querySnapshot = await getDocs(podQuery)
                this.tableData = [] // reiniciamos la data
                querySnapshot.forEach((doc) => {
                const data = doc.data()
                if (data.factura) {
                    let url = ''
                    const paqueteriaQuery = query(
                    collection(db, 'paqueterias'),
                    where('name', '==', data.paqueteria)
                    )
                    getDocs(paqueteriaQuery).then((qs2) => {
                    qs2.forEach((doc2) => {
                        const paqData = doc2.data()
                        if (paqData.url) {
                        url = paqData.url.replace("{NUM_RASTREO}", data.rastreo)
                        }
                    })
                    })
                    setTimeout(() => {
                    this.tableData.push({
                        choferNombre: data.choferNombre,
                        choferTelefono: data.choferTelefono,
                        clienteCodigo: data.clienteCodigo,
                        clienteNombre: data.clienteNombre,
                        dateFormatted: data.dateFormatted,
                        factura: data.factura,
                        fecha: data.fecha,
                        observaciones: data.observaciones,
                        paqueteria: data.paqueteria,
                        rastreo: data.rastreo,
                        recibio: data.recibio,
                        timestamp: moment(moment.unix(data.timestamp)).format("YYYY-MM-DD HH:mm"),
                        timestampRuta: moment(moment.unix(data.timestampRuta)).format("YYYY-MM-DD HH:mm"),
                        tipo_entrega: data.tipo_entrega,
                        ubicacion: data.ubicacion,
                        url_rastreo: url,
                        url_photo: data.url_photo
                    })
                    }, 400)
                }
                })
                this.showLoader = false
                this.showCargarMasBtnCEDIS = true
                this.filtroUsado = true
            } catch (error) {
                console.error("Error en filtrarCEDIS: ", error)
            }
        },
        sort(s) {
            //if s == current sort, reverse
            if(s === this.currentSort) {
                this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
            }
            this.currentSort = s;
        },
        async cargarPOD() {
            this.showLoader = true
            this.showCargarMasBtn = false
            this.facturaEncontrada = true
            this.showCargarMasBtnCEDIS = false
            this.tipo_pod = 'FACTURAS'
            const db = getFirestore()
            const lastFactura = this.tableData[this.tableData.length - 1].factura
            const podQuery = query(
                collection(db, "pod"),
                orderBy("factura", "desc"),
                startAt(lastFactura - 1),
                limit(100)
            )
            try {
                const querySnapshot = await getDocs(podQuery)
                querySnapshot.forEach((doc) => {
                const data = doc.data()
                if (data.factura) {
                    let url = ''
                    const paqueteriaQuery = query(
                    collection(db, 'paqueterias'),
                    where('name', '==', data.paqueteria)
                    )
                    getDocs(paqueteriaQuery).then((qs2) => {
                    qs2.forEach((doc2) => {
                        const paqData = doc2.data()
                        if (paqData.url) {
                        url = paqData.url.replace("{NUM_RASTREO}", data.rastreo)
                        }
                    })
                    })
                    setTimeout(() => {
                    this.tableData.push({
                        choferNombre: data.choferNombre,
                        choferTelefono: data.choferTelefono,
                        clienteCodigo: data.clienteCodigo,
                        clienteNombre: data.clienteNombre,
                        dateFormatted: data.dateFormatted,
                        factura: data.factura,
                        fecha: data.fecha,
                        observaciones: data.observaciones,
                        paqueteria: data.paqueteria,
                        rastreo: data.rastreo,
                        recibio: data.recibio,
                        timestamp: moment(moment.unix(data.timestamp)).format("YYYY-MM-DD HH:mm"),
                        timestampRuta: moment(moment.unix(data.timestampRuta)).format("YYYY-MM-DD HH:mm"),
                        tipo_entrega: data.tipo_entrega,
                        ubicacion: data.ubicacion,
                        url_rastreo: url,
                        url_photo: data.url_photo
                    })
                    }, 400)
                }
                })
                if (querySnapshot.empty || querySnapshot.size < 50) {
                this.showCargarMasBtn = false
                } else {
                this.showCargarMasBtn = true
                }
                this.showLoader = false
            } catch (error) {
                console.error("Error en cargarPOD: ", error)
            }
        },
        async cargarCEDISPOD() {
            this.showLoader = true
            this.showCargarMasBtn = false
            this.facturaEncontrada = true
            this.tipo_pod = 'FACTURAS'
            const db = getFirestore()
            const lastFactura = this.tableData[this.tableData.length - 1].factura
            const podQuery = query(
                collection(db, "pod"),
                where('ubicacion', '==', this.cedis_busqueda + '-02'),
                orderBy("factura", "desc"),
                startAt(lastFactura - 1),
                limit(100)
            )
            try {
                const querySnapshot = await getDocs(podQuery)
                querySnapshot.forEach((doc) => {
                const data = doc.data()
                if (data.factura) {
                    let url = ''
                    const paqueteriaQuery = query(
                    collection(db, 'paqueterias'),
                    where('name', '==', data.paqueteria)
                    )
                    getDocs(paqueteriaQuery).then((qs2) => {
                    qs2.forEach((doc2) => {
                        const paqData = doc2.data()
                        if (paqData.url) {
                        url = paqData.url.replace("{NUM_RASTREO}", data.rastreo)
                        }
                    })
                    })
                    setTimeout(() => {
                    this.tableData.push({
                        choferNombre: data.choferNombre,
                        choferTelefono: data.choferTelefono,
                        clienteCodigo: data.clienteCodigo,
                        clienteNombre: data.clienteNombre,
                        dateFormatted: data.dateFormatted,
                        factura: data.factura,
                        fecha: data.fecha,
                        observaciones: data.observaciones,
                        paqueteria: data.paqueteria,
                        rastreo: data.rastreo,
                        recibio: data.recibio,
                        timestamp: moment(moment.unix(data.timestamp)).format("YYYY-MM-DD HH:mm"),
                        timestampRuta: moment(moment.unix(data.timestampRuta)).format("YYYY-MM-DD HH:mm"),
                        tipo_entrega: data.tipo_entrega,
                        ubicacion: data.ubicacion,
                        url_rastreo: url,
                        url_photo: data.url_photo
                    })
                    }, 400)
                }
                })
                if (querySnapshot.empty || querySnapshot.size < 50) {
                this.showCargarMasBtnCEDIS = false
                } else {
                this.showCargarMasBtnCEDIS = true
                }
                this.showLoader = false
            } catch (error) {
                console.error("Error en cargarCEDISPOD: ", error)
            }
        },
        async buscarFactura() {
            this.tipo_pod = 'FACTURAS'
            this.filtroUsado = true
            this.showCargarMasBtnCEDIS = false
            const db = getFirestore()
            const facturaNum = parseInt(this.busqueda)
            const podQuery = query(
                collection(db, 'pod'),
                where('factura', '==', facturaNum)
            )
            try {
                const querySnapshot = await getDocs(podQuery)
                if (querySnapshot.size === 0) {
                this.tableData = []
                this.facturaEncontrada = false
                } else {
                this.facturaEncontrada = true
                this.tableData = []
                querySnapshot.forEach((doc) => {
                    const data = doc.data()
                    if (data.factura) {
                    let url = ''
                    const paqueteriaQuery = query(
                        collection(db, 'paqueterias'),
                        where('name', '==', data.paqueteria)
                    )
                    getDocs(paqueteriaQuery).then((qs2) => {
                        qs2.forEach((doc2) => {
                        const paqData = doc2.data()
                        if (paqData.url) {
                            url = paqData.url.replace("{NUM_RASTREO}", data.rastreo)
                        }
                        })
                    })
                    setTimeout(() => {
                        this.tableData.push({
                        choferNombre: data.choferNombre,
                        choferTelefono: data.choferTelefono,
                        clienteCodigo: data.clienteCodigo,
                        clienteNombre: data.clienteNombre,
                        dateFormatted: data.dateFormatted,
                        factura: data.factura,
                        fecha: data.fecha,
                        observaciones: data.observaciones,
                        paqueteria: data.paqueteria,
                        rastreo: data.rastreo,
                        recibio: data.recibio,
                        timestamp: moment(moment.unix(data.timestamp)).format("YYYY-MM-DD HH:mm"),
                        timestampRuta: moment(moment.unix(data.timestampRuta)).format("YYYY-MM-DD HH:mm"),
                        tipo_entrega: data.tipo_entrega,
                        ubicacion: data.ubicacion,
                        url_rastreo: url,
                        url_photo: data.url_photo
                        })
                    }, 400)
                    }
                })
                }
            } catch (error) {
                console.error("Error en buscarFactura: ", error)
            }
        },
        async mostrarTodo() {
            this.tipo_pod = 'FACTURAS'
            this.busqueda = ''
            this.facturaEncontrada = true
            this.showCargarMasBtnCEDIS = false
            this.cedis_busqueda = 'Selecciona un CEDIS'
            const db = getFirestore()
            const podQuery = query(
            collection(db, "pod"),
            orderBy("timestamp", "desc"),
            limit(100)
            )
            try {
            const querySnapshot = await getDocs(podQuery)
            this.tableData = [] // reiniciamos la data
            querySnapshot.forEach((doc) => {
                const data = doc.data()
                if (data.factura) {
                let url = ''
                const paqueteriaQuery = query(
                    collection(db, 'paqueterias'),
                    where('name', '==', data.paqueteria)
                )
                getDocs(paqueteriaQuery).then((qs2) => {
                    qs2.forEach((doc2) => {
                    const paqData = doc2.data()
                    if (paqData.url) {
                        url = paqData.url.replace("{NUM_RASTREO}", data.rastreo)
                    }
                    })
                })
                setTimeout(() => {
                    this.tableData.push({
                    choferNombre: data.choferNombre,
                    choferTelefono: data.choferTelefono,
                    clienteCodigo: data.clienteCodigo,
                    clienteNombre: data.clienteNombre,
                    dateFormatted: data.dateFormatted,
                    factura: data.factura,
                    fecha: data.fecha,
                    observaciones: data.observaciones,
                    paqueteria: data.paqueteria,
                    rastreo: data.rastreo,
                    recibio: data.recibio,
                    timestamp: moment(moment.unix(data.timestamp)).format("YYYY-MM-DD HH:mm"),
                    timestampRuta: moment(moment.unix(data.timestampRuta)).format("YYYY-MM-DD HH:mm"),
                    tipo_entrega: data.tipo_entrega,
                    ubicacion: data.ubicacion,
                    url_rastreo: url,
                    url_photo: data.url_photo
                    })
                }, 400)
                }
            })
            this.showLoader = false
            this.showCargarMasBtn = true
            this.filtroUsado = false
            } catch (error) {
            console.error("Error en mostrarTodo: ", error)
            }
        },
        async mostrarTraslados() {
            this.tipo_pod = "TRASLADOS"
            this.busqueda = ''
            this.cedis_busqueda = 'Selecciona un CEDIS'
            this.showCargarMasBtnCEDIS = false
            const db = getFirestore()
            const trasladosQuery = query(
                collection(db, "traslados"),
                orderBy("traslado", "desc"),
                limit(100)
            )
            try {
                const querySnapshot = await getDocs(trasladosQuery)
                this.tableDataTraslado = [] // reiniciamos la data
                querySnapshot.forEach((doc) => {
                const data = doc.data()
                if (data.traslado) {
                    let url = ''
                    const paqueteriaQuery = query(
                    collection(db, 'paqueterias'),
                    where('name', '==', data.paqueteria)
                    )
                    getDocs(paqueteriaQuery).then((qs2) => {
                    qs2.forEach((doc2) => {
                        const paqData = doc2.data()
                        if (paqData.url) {
                        url = paqData.url.replace("{NUM_RASTREO}", data.rastreo)
                        }
                    })
                    })
                    setTimeout(() => {
                    this.tableDataTraslado.push({
                        choferNombre: data.choferNombre,
                        choferTelefono: data.choferTelefono,
                        destino: data.destino,
                        dateFormatted: data.dateFormatted,
                        traslado: data.traslado,
                        fecha: data.fecha,
                        observaciones: data.observaciones,
                        paqueteria: data.paqueteria,
                        rastreo: data.rastreo,
                        timestamp: data.timestamp,
                        ubicacion: data.ubicacion,
                        url_rastreo: url,
                        url_photo: data.url_photo
                    })
                    }, 400)
                }
                })
                this.showLoader = false
                this.showCargarMasTrasladosBtn = true
                this.filtroTrasladoUsado = false
            } catch (error) {
                console.error("Error en mostrarTraslados: ", error)
            }
        },
        async cargarTraslados() {
            this.showLoader = true
            this.showCargarMasTrasladosBtn = false
            this.showCargarMasBtnCEDIS = false
            this.tipo_pod = "TRASLADOS"
            const db = getFirestore()
            // Se asume que el número de traslado tiene formato 'T<number>'
            const lastTraslado = parseInt(this.tableDataTraslado[this.tableDataTraslado.length - 1].traslado.slice(1)) - 1
            const trasladosQuery = query(
                collection(db, "traslados"),
                orderBy("traslado", "desc"),
                startAt('T' + lastTraslado),
                limit(100)
            )
            try {
                const querySnapshot = await getDocs(trasladosQuery)
                querySnapshot.forEach((doc) => {
                const data = doc.data()
                if (data.traslado) {
                    let url = ''
                    const paqueteriaQuery = query(
                    collection(db, 'paqueterias'),
                    where('name', '==', data.paqueteria)
                    )
                    getDocs(paqueteriaQuery).then((qs2) => {
                    qs2.forEach((doc2) => {
                        const paqData = doc2.data()
                        if (paqData.url) {
                        url = paqData.url.replace("{NUM_RASTREO}", data.rastreo)
                        }
                    })
                    })
                    setTimeout(() => {
                    this.tableDataTraslado.push({
                        choferNombre: data.choferNombre,
                        choferTelefono: data.choferTelefono,
                        destino: data.destino,
                        dateFormatted: data.dateFormatted,
                        traslado: data.traslado,
                        fecha: data.fecha,
                        observaciones: data.observaciones,
                        paqueteria: data.paqueteria,
                        rastreo: data.rastreo,
                        timestamp: data.timestamp,
                        ubicacion: data.ubicacion,
                        url_rastreo: url,
                        url_photo: data.url_photo
                    })
                    }, 400)
                }
                })
                if (querySnapshot.empty || querySnapshot.size < 50) {
                this.showCargarMasTrasladosBtn = false
                } else {
                this.showCargarMasTrasladosBtn = true
                }
                this.showLoader = false
            } catch (error) {
                console.error("Error en cargarTraslados: ", error)
            }
        },
        async buscarTraslado() {
            this.tipo_pod = 'TRASLADOS'
            this.filtroTrasladoUsado = true
            this.showCargarMasBtnCEDIS = false
            if (this.busquedaTraslado.charAt(0) !== 'T') {
                this.busquedaTraslado = 'T' + this.busquedaTraslado
            }
            const db = getFirestore()
            const trasladosQuery = query(
                collection(db, 'traslados'),
                where('traslado', '==', this.busquedaTraslado)
            )
            try {
                const querySnapshot = await getDocs(trasladosQuery)
                this.tableDataTraslado = [] // reiniciamos la data
                querySnapshot.forEach((doc) => {
                const data = doc.data()
                if (data.traslado) {
                    let url = ''
                    const paqueteriaQuery = query(
                    collection(db, 'paqueterias'),
                    where('name', '==', data.paqueteria)
                    )
                    getDocs(paqueteriaQuery).then((qs2) => {
                    qs2.forEach((doc2) => {
                        const paqData = doc2.data()
                        if (paqData.url) {
                        url = paqData.url.replace("{NUM_RASTREO}", data.rastreo)
                        }
                    })
                    })
                    setTimeout(() => {
                    this.tableDataTraslado.push({
                        choferNombre: data.choferNombre,
                        choferTelefono: data.choferTelefono,
                        destino: data.destino,
                        dateFormatted: data.dateFormatted,
                        traslado: data.traslado,
                        fecha: data.fecha,
                        observaciones: data.observaciones,
                        paqueteria: data.paqueteria,
                        rastreo: data.rastreo,
                        timestamp: data.timestamp,
                        ubicacion: data.ubicacion,
                        url_rastreo: url,
                        url_photo: data.url_photo
                    })
                    }, 400)
                }
                })
            } catch (error) {
                console.error("Error en buscarTraslado: ", error)
            }
        },
        moment: function () {
            return moment();
        }
    }
  };
</script>
<style>
/* Banner nueva versión */
.new-version-card {
  border: none;
  overflow: hidden;
}
.new-version-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 60px 40px;
  background: linear-gradient(135deg, #fff5f5 0%, #fff 100%);
}
.new-version-icon {
  font-size: 3.5rem;
  color: #f5365c;
  margin-bottom: 20px;
  animation: bounce 1.4s infinite;
}
@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-10px); }
}
.new-version-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #32325d;
  margin-bottom: 14px;
}
.new-version-text {
  font-size: 1.05rem;
  color: #525f7f;
  max-width: 520px;
  line-height: 1.7;
  margin-bottom: 32px;
}
.btn-new-version {
  display: inline-flex;
  align-items: center;
  padding: 14px 36px;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 50px;
  color: #fff !important;
  background: linear-gradient(87deg, #f5365c 0, #f55f36 200%);
  border: none;
  box-shadow: 0 6px 20px rgba(245, 54, 92, 0.35);
  text-decoration: none;
  transition: transform 0.15s, box-shadow 0.15s;
}
.btn-new-version:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(245, 54, 92, 0.45);
}
.btn-it-authorization {
  margin-top: 18px;
  background: transparent;
  border: none;
  color: #8898aa;
  font-size: 0.85rem;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  padding: 6px 12px;
  transition: color 0.15s;
}
.btn-it-authorization:hover {
  color: #525f7f;
}
.btn-it-authorization:focus {
  outline: none;
}
</style>
